export default (($, /* eslint-disable */ window, undefined /* eslint-enable */) => {
  const sendScTracking = async (goalID) => {
    const API_URL = '/sc/api/Analytics/TriggerAnalyticsGoal';
    
  
    $.ajax({
      url: API_URL,
      cache: false,
      type: 'POST',
      dataType: 'json',
      data: { id: goalID },
      // for testing
      /*
      success: (resp) => {
        console.log(`Goal was successfully triggered, with goalid:${goalID}`);
      },
      error: () => {
        console.log(`Error sending tracking request, goalid:${goalID}`);
      }
      */
    });
  };

  return {
    sendScTracking
  };
})(jQuery, window);